import * as React from 'react';
import { Container, Row, Col } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPodcast } from '@fortawesome/free-solid-svg-icons';
import { stat } from 'fs';
import { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import ChannelList from "./channelList";
import ChannelDetail from "./channelDetail";
import { Capitalize } from '../common/functions';

class ChannelsPageComponent extends React.Component {
	state = {
		isView: false,
		selectedId: false,
		dropdownShopOpen: false,
		page: "",
		id: -1,
		title: "",
		code: "",
		langcode: ""
	}
	constructor(props: any) {
		super(props);
		this.state = {
			isView: false,
			selectedId: false,
			dropdownShopOpen: false,
			page: "",
			id: -1,
			title: "",
			code: "",
			langcode: ""
		}
		this.handleCallbackMethod = this.handleCallbackMethod.bind(this);
	}

	componentDidMount() {
		var tokenstr = (new URLSearchParams(window.location.search))?.get("page");
		var tValue = tokenstr == null ? "" : tokenstr
		var idstr = (new URLSearchParams(window.location.search)).get("id");
		var id = idstr == null ? -1 : parseInt(idstr);
		var codestr = (new URLSearchParams(window.location.search)).get("code");
		var codeValue = codestr == null ? "" : codestr;
		var langCode = localStorage.getItem("langCode"); 
		var langcodeValue = langCode == null ? "" : JSON.parse(langCode);
		var pageValue = (id >= 0 || (codeValue && codeValue != '')) ? "detail" : tValue;
		this.setState({
			...stat,
			page: pageValue,
			id: id,
			code: codeValue,
			isView: pageValue == "" ? true : false,
			langcode: langcodeValue
		});
		
		var alertMessage = window.localStorage.getItem('alertMessage');
		if (alertMessage && alertMessage != "") {
			store.addNotification({
				title: "Success!",
				message: alertMessage,
				type: "success",
				insert: "top",
				container: "top-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true
				}
			});
			window.localStorage.setItem('alertMessage', "");
		}

		document.title = `${pageValue==="" ? "Channels" : "Channel"} - Daily Audio Bible Administration`;
	}


	handleCallbackMethod(value) {
		this.setState({ title: value });
	}
	render() {
		const { title } = this.state;
			console.log(title)
		return (
			<div>
				<Container>
					<Row>
						<Col lg="12">
							{this.state.page == "add" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faPodcast} />
										<span data-testid="channelPageTitle"> Channels - Create New</span>
									</h2>
									<hr />
									<ChannelDetail callback={this.handleCallbackMethod} id={this.state.id} uniqueCode={""} />
								</div>
							)}
							{this.state.page == "detail" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faPodcast} />
										<span data-testid="channelPageTitle"> Channels - {title} Details</span>
									</h2>
									<hr />
									<ChannelDetail callback={this.handleCallbackMethod} id={this.state.id} uniqueCode={this.state.code} />
								</div>
							)}
							{this.state.page == "" && this.state.isView && (<div>
								<h2>
									<FontAwesomeIcon icon={faPodcast} />
									<span data-testid="channelPageTitle"> Channels</span>
								</h2>
								<hr />
								<ChannelList langcode={this.state.langcode} />
							</div>)}
						</Col>
						<Col />
					</Row>
				</Container>
			</div>
		);
	}
}

export default ChannelsPageComponent;